"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Button", {
    enumerable: true,
    get: function() {
        return Button;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _bs = require("react-icons/bs");
const _color = /*#__PURE__*/ _interop_require_default(require("color"));
const _Theme = require("../../contexts/Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const defaultSize = "md";
const Button = /*#__PURE__*/ _react.default.forwardRef((param, ref)=>{
    let { children, variant = "primary", dropdownToggle = false, color: colorInput, ...props } = param;
    const theme = (0, _Theme.useTheme)();
    const { animationDuration, focusOutline, mutedOpacity, spacers } = theme;
    const btnColors = (0, _react.useMemo)(()=>{
        const twentyPercent = 0.2;
        const custom = ((obj)=>obj == null ? undefined : {
                color: colorInput,
                contrast: obj.isDark() ? theme.colors.white : theme.colors.dark,
                darker: obj.darken(twentyPercent)
            })(colorInput != null ? (0, _color.default)(colorInput) : undefined);
        var _custom_color, _custom_color1, _custom_color2, _custom_color3, _custom_contrast, _custom_color4, _custom_darker, _custom_darker1, _custom_darker2, _custom_darker3, _custom_contrast1, _custom_color5;
        return {
            border: ({
                secondary: "1.5px solid ".concat((_custom_color = custom === null || custom === void 0 ? void 0 : custom.color) !== null && _custom_color !== void 0 ? _custom_color : theme.colors.buttonBorder),
                primary: "1.5px solid ".concat((_custom_color1 = custom === null || custom === void 0 ? void 0 : custom.color) !== null && _custom_color1 !== void 0 ? _custom_color1 : theme.colors.primary),
                link: "none"
            })[variant],
            background: ({
                secondary: "none",
                primary: (_custom_color2 = custom === null || custom === void 0 ? void 0 : custom.color) !== null && _custom_color2 !== void 0 ? _custom_color2 : theme.colors.primary,
                link: "none"
            })[variant],
            color: ({
                secondary: (_custom_color3 = custom === null || custom === void 0 ? void 0 : custom.color) !== null && _custom_color3 !== void 0 ? _custom_color3 : theme.colors.dark,
                primary: (_custom_contrast = custom === null || custom === void 0 ? void 0 : custom.contrast) !== null && _custom_contrast !== void 0 ? _custom_contrast : theme.colors.primaryContrast,
                link: (_custom_color4 = custom === null || custom === void 0 ? void 0 : custom.color) !== null && _custom_color4 !== void 0 ? _custom_color4 : theme.colors.dark
            })[variant],
            hover: {
                border: ({
                    secondary: "1.5px solid ".concat((_custom_darker = custom === null || custom === void 0 ? void 0 : custom.darker) !== null && _custom_darker !== void 0 ? _custom_darker : theme.colors.lightContrast),
                    primary: "1.5px solid ".concat((_custom_darker1 = custom === null || custom === void 0 ? void 0 : custom.darker) !== null && _custom_darker1 !== void 0 ? _custom_darker1 : theme.colors.primary),
                    link: "none"
                })[variant],
                background: ({
                    secondary: "none",
                    primary: (_custom_darker2 = custom === null || custom === void 0 ? void 0 : custom.darker) !== null && _custom_darker2 !== void 0 ? _custom_darker2 : theme.colors.primaryShades.darker.bg,
                    link: "none"
                })[variant],
                color: ({
                    secondary: (_custom_darker3 = custom === null || custom === void 0 ? void 0 : custom.darker) !== null && _custom_darker3 !== void 0 ? _custom_darker3 : theme.colors.dark,
                    primary: (_custom_contrast1 = custom === null || custom === void 0 ? void 0 : custom.contrast) !== null && _custom_contrast1 !== void 0 ? _custom_contrast1 : theme.colors.primaryShades.darker.fg,
                    link: (_custom_color5 = custom === null || custom === void 0 ? void 0 : custom.color) !== null && _custom_color5 !== void 0 ? _custom_color5 : theme.colors.dark
                })[variant]
            }
        };
    }, [
        theme.colors,
        variant,
        colorInput
    ]);
    var _props_size, _props_size1, _props_size2, _props_size3, _props_size4, _props_size5, _props_size6, _props_size7, _props_size8, _props_size9, _props_size10, _props_size11, _props_size12, _props_size13, _props_size14;
    return /*#__PURE__*/ _react.default.createElement("button", {
        ref: ref,
        ...props,
        className: "jsx-ebed2536c9199f9e " + _style.default.dynamic([
            [
                "ec485d25ec9cce7",
                [
                    props.round === true ? "50%" : "4px",
                    props.round === true ? "auto" : "nowrap",
                    props.round !== true ? "auto" : ({
                        sm: "32px",
                        md: "48px",
                        lg: "64px"
                    })[(_props_size = props.size) !== null && _props_size !== void 0 ? _props_size : defaultSize],
                    props.round !== true ? "auto" : ({
                        sm: "32px",
                        md: "48px",
                        lg: "64px"
                    })[(_props_size1 = props.size) !== null && _props_size1 !== void 0 ? _props_size1 : defaultSize],
                    btnColors.background,
                    btnColors.border,
                    btnColors.color,
                    dropdownToggle ? "14px" : props.round === true ? "16px" : ({
                        sm: "12px",
                        md: "16px"
                    })[(_props_size2 = props.size) !== null && _props_size2 !== void 0 ? _props_size2 : defaultSize],
                    dropdownToggle ? "22px" : props.round === true ? "16px" : ({
                        sm: "20px",
                        md: "24px"
                    })[(_props_size3 = props.size) !== null && _props_size3 !== void 0 ? _props_size3 : defaultSize],
                    props.round === true ? "0" : ({
                        sm: "4px 14.5px",
                        md: "8px 18.5px"
                    })[(_props_size4 = props.size) !== null && _props_size4 !== void 0 ? _props_size4 : defaultSize],
                    animationDuration,
                    btnColors.hover.background,
                    btnColors.hover.border,
                    btnColors.hover.color,
                    variant === "link" ? "underline" : "none",
                    focusOutline.size,
                    focusOutline.colors.default,
                    mutedOpacity,
                    btnColors.background,
                    btnColors.border
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || "")
    }, children, " ", dropdownToggle && /*#__PURE__*/ _react.default.createElement(_bs.BsChevronDown, {
        size: 10,
        style: {
            marginRight: "-".concat(spacers.s3, "px"),
            marginTop: "".concat(spacers.s0, "px")
        }
    }), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "ebed2536c9199f9e"
    }, "button.jsx-ebed2536c9199f9e{cursor:pointer;font-weight:500}"), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "ec485d25ec9cce7",
        dynamic: [
            props.round === true ? "50%" : "4px",
            props.round === true ? "auto" : "nowrap",
            props.round !== true ? "auto" : ({
                sm: "32px",
                md: "48px",
                lg: "64px"
            })[(_props_size5 = props.size) !== null && _props_size5 !== void 0 ? _props_size5 : defaultSize],
            props.round !== true ? "auto" : ({
                sm: "32px",
                md: "48px",
                lg: "64px"
            })[(_props_size6 = props.size) !== null && _props_size6 !== void 0 ? _props_size6 : defaultSize],
            btnColors.background,
            btnColors.border,
            btnColors.color,
            dropdownToggle ? "14px" : props.round === true ? "16px" : ({
                sm: "12px",
                md: "16px"
            })[(_props_size7 = props.size) !== null && _props_size7 !== void 0 ? _props_size7 : defaultSize],
            dropdownToggle ? "22px" : props.round === true ? "16px" : ({
                sm: "20px",
                md: "24px"
            })[(_props_size8 = props.size) !== null && _props_size8 !== void 0 ? _props_size8 : defaultSize],
            props.round === true ? "0" : ({
                sm: "4px 14.5px",
                md: "8px 18.5px"
            })[(_props_size9 = props.size) !== null && _props_size9 !== void 0 ? _props_size9 : defaultSize],
            animationDuration,
            btnColors.hover.background,
            btnColors.hover.border,
            btnColors.hover.color,
            variant === "link" ? "underline" : "none",
            focusOutline.size,
            focusOutline.colors.default,
            mutedOpacity,
            btnColors.background,
            btnColors.border
        ]
    }, "button.__jsx-style-dynamic-selector{-webkit-border-radius:".concat(props.round === true ? "50%" : "4px", ";-moz-border-radius:").concat(props.round === true ? "50%" : "4px", ";border-radius:").concat(props.round === true ? "50%" : "4px", ";white-space:").concat(props.round === true ? "auto" : "nowrap", ";overflow:hidden;width:").concat(props.round !== true ? "auto" : ({
        sm: "32px",
        md: "48px",
        lg: "64px"
    })[(_props_size10 = props.size) !== null && _props_size10 !== void 0 ? _props_size10 : defaultSize], ";height:").concat(props.round !== true ? "auto" : ({
        sm: "32px",
        md: "48px",
        lg: "64px"
    })[(_props_size11 = props.size) !== null && _props_size11 !== void 0 ? _props_size11 : defaultSize], ";background:").concat(btnColors.background, ";border:").concat(btnColors.border, ";color:").concat(btnColors.color, ";font-size:").concat(dropdownToggle ? "14px" : props.round === true ? "16px" : ({
        sm: "12px",
        md: "16px"
    })[(_props_size12 = props.size) !== null && _props_size12 !== void 0 ? _props_size12 : defaultSize], ";line-height:").concat(dropdownToggle ? "22px" : props.round === true ? "16px" : ({
        sm: "20px",
        md: "24px"
    })[(_props_size13 = props.size) !== null && _props_size13 !== void 0 ? _props_size13 : defaultSize], ";padding:").concat(props.round === true ? "0" : ({
        sm: "4px 14.5px",
        md: "8px 18.5px"
    })[(_props_size14 = props.size) !== null && _props_size14 !== void 0 ? _props_size14 : defaultSize], ";outline:none;-webkit-transition:box-shadow ").concat(animationDuration, ";-moz-transition:box-shadow ").concat(animationDuration, ";-o-transition:box-shadow ").concat(animationDuration, ";transition:box-shadow ").concat(animationDuration, ';text-transform:"none"}button.__jsx-style-dynamic-selector:hover,button.__jsx-style-dynamic-selector:focus,button.__jsx-style-dynamic-selector:active,button.__jsx-style-dynamic-selector:active:focus{background:').concat(btnColors.hover.background, ";border:").concat(btnColors.hover.border, ";color:").concat(btnColors.hover.color, ";-webkit-text-decoration:").concat(variant === "link" ? "underline" : "none", ";-moz-text-decoration:").concat(variant === "link" ? "underline" : "none", ";text-decoration:").concat(variant === "link" ? "underline" : "none", ";text-underline-position:under}button.__jsx-style-dynamic-selector:focus-visible{-webkit-box-shadow:0px 0px 0px ").concat(focusOutline.size, " ").concat(focusOutline.colors.default, ";-moz-box-shadow:0px 0px 0px ").concat(focusOutline.size, " ").concat(focusOutline.colors.default, ";box-shadow:0px 0px 0px ").concat(focusOutline.size, " ").concat(focusOutline.colors.default, "}button.__jsx-style-dynamic-selector:disabled,button.__jsx-style-dynamic-selector:disabled button.__jsx-style-dynamic-selector:hover,button.__jsx-style-dynamic-selector:disabled button.__jsx-style-dynamic-selector:focus,button.__jsx-style-dynamic-selector:disabled button.__jsx-style-dynamic-selector:active,button.__jsx-style-dynamic-selector:disabled button.__jsx-style-dynamic-selector:active:focus{opacity:").concat(mutedOpacity, ";cursor:not-allowed;text-decoration:none;background:").concat(btnColors.background, ";border:").concat(btnColors.border, ";-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}")));
});
Button.displayName = "Button";

//# sourceMappingURL=Button.js.map